module.exports = __webpack_public_path__ + "img/mail.6f9afa4b.svg";